import FormField from 'components/FormField';
import { FV, storeScopes2applyScope, useApplyScope2storeScopes } from './share';
import { useTranslate } from '@tolgee/react';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import { StoreScopesModal, getStoreCount } from 'components/StoreScopes';
import useModal from 'hooks/useModal';
import { Content } from 'views/Aide/Scenario/TaskForm/StoreScopesField';
import { Button } from 'antd';
import { ReactNode } from 'react';
import PopoverPreview from 'components/StoreScopes/PopoverPreview';

function ApplyScope() {
  const { t } = useTranslate();

  const { visible, show, hide } = useModal();

  const { applyScope2storeScopes } = useApplyScope2storeScopes({
    permId: permissionNameIdMap['重要提醒'],
  });

  return (
    <FormField<FV['applyScope']>
      required
      name="applyScope"
      label={t('aide.应用店铺')}
      validate={(value) => {
        if (value.scope === 'ALL') {
          return undefined;
        }

        const scopes = applyScope2storeScopes(value);

        const storeCount = getStoreCount(scopes);

        return storeCount === 0 ? t('aide.请选择应用店铺') : undefined;
      }}
    >
      {({ field: { value, onChange } }) => {
        const isAllStores = value.scope === 'ALL';

        const scopes = isAllStores ? [] : applyScope2storeScopes(value);

        const modal = (
          <StoreScopesModal
            permId={permissionNameIdMap['重要提醒']}
            visible={visible}
            supportWa={false}
            showFooterTips={false}
            onCancel={hide}
            value={scopes}
            onChange={(scopes) => onChange(storeScopes2applyScope(scopes))}
          />
        );

        const render = (contentText: ReactNode, editText: ReactNode) => {
          return (
            <Content>
              {contentText && <div>{contentText}</div>}
              <Button type="link" onClick={show}>
                {editText}
              </Button>
              {modal}
            </Content>
          );
        };

        if (isAllStores) {
          return render(t('department.全部店铺'), t('phrase.重新选择'));
        }

        const storeCount = getStoreCount(scopes);

        if (storeCount === 0) {
          return render(null, t('remind.选择店铺'));
        }

        return render(<PopoverPreview value={scopes} />, t('phrase.重新选择'));
      }}
    </FormField>
  );
}

export default ApplyScope;
